import { Component } from '@angular/core';
import { FeeType, FeeTypeDisplayValue } from '../../../../models';
import { ManageSupplierService } from '../../manage-supplier.service';

@Component({
    selector: 'supplier-implementation-summary-cards',
    styleUrls: ['./supplier-implementation-summary-cards.component.scss'],
    template: `
        <div [style.marginBottom]="'3rem'" class="row">
            <card [headerTitle]="'Default Settings'" class="col-lg-6 col-12">
                <div card-body class="implementation-card-body">
                    <div class="setting-item row">
                        <div class="col-4">Fee Structure:</div>
                        <div class="col-3" id="fee-structure-default-config">
                            <b>{{ feeTypeDisplay[defaultSettings.feeStructure] }}</b>
                        </div>

                        <div class="col-4">Fee Rate:</div>
                        <div class="col-2" id="fee-rate-default-config">
                            <b> {{ defaultSettings.feeRate?? '--' }}</b>
                        </div>
                    </div>

                    <div class="setting-item row">
                        <div class="col-4">Buyer Paid Early Payment %:</div>
                        <div class="col-3" id="buyer-early-payment-default-config">
                            <b>
                                {{
                                    defaultSettings.buyerPaidEarlyPayment
                                        ? (defaultSettings.buyerPaidEarlyPayment | lsqPercent)
                                        : '--'
                                }}</b
                            >
                        </div>

                        <div class="col-4">Supplier Paid Early Payment %:</div>
                        <div class="col-2" id="supplier-early-payment-default-config">
                            <b>{{
                                defaultSettings.supplierPaidEarlyPayment &&
                                defaultSettings.buyerPaidEarlyPayment
                                    ? (defaultSettings.supplierPaidEarlyPayment | lsqPercent)
                                    : '--'
                            }}</b>
                        </div>
                    </div>

                    <div class="setting-item row">
                        <div class="col-4">Buyer Paid Delivery Fees:</div>
                        <div class="col-3" id="buyer-paid-default-config">
                            <b>{{ defaultSettings.buyerPaidDeliveryFees?? '--'}}</b>
                        </div>

                        <div class="col-4">Ineligible Days Before Terms:</div>
                        <div class="col-2" id="ineligible-days-default-config">
                            <b>{{ defaultSettings.ineligibleDaysBeforeTerms?? '--' }}</b>
                        </div>
                    </div>
                </div>
            </card>

            <card [headerTitle]="'Current Settings'" class="col-lg-6 col-12">
                <div card-body class="implementation-card-body">
                    <div class="setting-item row">
                        <div class="col-4">Fee Structure:</div>
                        <div class="col-3" id="fee-structure-current-config">
                            <b
                                [ngClass]="{
                                    highlight:
                                        currentOverridingSettings.feeStructure !==
                                        currentSettings.feeStructure
                                }"
                                >{{ feeTypeDisplay[currentOverridingSettings.feeStructure] }}</b
                            >
                        </div>

                        <div class="col-4">Fee Rate:</div>
                        <div class="col-2" id="fee-rate-current-config">
                            <b
                                [ngClass]="{
                                    highlight:
                                        currentOverridingSettings.feeRate !==
                                        currentSettings.feeRate
                                }"
                            >
                                {{ currentOverridingSettings.feeRate?? '--' }}</b
                            >
                        </div>
                    </div>

                    <div class="setting-item row">
                        <div class="col-4">Buyer Paid Early Payment %:</div>
                        <div class="col-3" id="buyer-early-payment-current-config">
                            <b
                                [ngClass]="{
                                    highlight:
                                        currentOverridingSettings.buyerPaidEarlyPayment !==
                                        currentSettings.buyerPaidEarlyPayment
                                }"
                            >
                                {{
                                    currentOverridingSettings.buyerPaidEarlyPayment
                                        ? (currentOverridingSettings.buyerPaidEarlyPayment
                                          | lsqPercent)
                                        : '--'
                                }}</b
                            >
                        </div>

                        <div class="col-4">Supplier Paid Early Payment %:</div>
                        <div class="col-2" id="supplier-early-payment-current-config">
                            <b
                                [ngClass]="{
                                    highlight:
                                        currentOverridingSettings.supplierPaidEarlyPayment !==
                                        currentSettings.supplierPaidEarlyPayment
                                }"
                                >{{
                                    currentSettings.supplierPaidEarlyPayment &&
                                    currentSettings.buyerPaidEarlyPayment
                                        ? (currentOverridingSettings.supplierPaidEarlyPayment
                                          | lsqPercent)
                                        : '--'
                                }}</b
                            >
                        </div>
                    </div>

                    <div class="setting-item row">
                        <div class="col-4">Buyer Paid Delivery Fees:</div>
                        <div class="col-3" id="buyer-paid-current-config">
                            <b
                                [ngClass]="{
                                    highlight:
                                        currentOverridingSettings.buyerPaidDeliveryFees !==
                                        currentSettings.buyerPaidDeliveryFees
                                }"
                                >{{ currentOverridingSettings.buyerPaidDeliveryFees?? '--'}}</b
                            >
                        </div>

                        <div class="col-4">Ineligible Days Before Terms:</div>
                        <div class="col-2" id="ineligible-days-current-config">
                            <b
                                [ngClass]="{
                                    highlight:
                                        currentOverridingSettings.ineligibleDaysBeforeTerms !==
                                        currentSettings.ineligibleDaysBeforeTerms
                                }"
                                >{{ currentOverridingSettings.ineligibleDaysBeforeTerms?? '--' }}</b
                            >
                        </div>
                    </div>
                </div>
            </card>
        </div>
    `
})
export class ManageSupplierImplementationSummaryCardsComponent {
    public supplierRelationship$ = this._manageSupplierService.currentSupplierRelationship$;
    public feeType = FeeType;
    public feeTypeDisplay = FeeTypeDisplayValue;

    public isOverridingFee = false;

    constructor(private _manageSupplierService: ManageSupplierService) {}

    public get defaultSettings() {
        return this._manageSupplierService.defaultSettings;
    }

    public get currentSettings() {
        return this._manageSupplierService.currentSettings;
    }

    public get currentOverridingSettings() {
        return this._manageSupplierService.currentOverridingSettings;
    }
}
